module.exports = __webpack_public_path__ + "84c80490c53db6aacdc67642f484b9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/promotion.png
// module id = 3713
// module chunks = 2